import React, { useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { FaFilePdf } from 'react-icons/fa';
import Toast from '../../../Util/Toast/Toast';

const PDFGeneratorButton = ({ headerRef, serviceLetters }) => {
    const [isGenerating, setIsGenerating] = useState(false);

    const generatePDF = async () => {
        const toastId = Toast.info('Gerando PDF...', '', {
            autoClose: false 
        });
        
        setIsGenerating(true);

        try {
            const pdf = new jsPDF();

            const headerElement = headerRef.current;
            const headerCanvas = await html2canvas(headerElement, {
                scale: 2,
                useCORS: true
            });
            const headerImgData = headerCanvas.toDataURL('image/png');
            const headerHeight =
                (headerCanvas.height * pdf.internal.pageSize.getWidth()) /
                headerCanvas.width;

            for (let i = 0; i < serviceLetters.length; i++) {
                const serviceLetterElement = document.getElementById(
                    `serviceLetter-${i}`
                );
                if (serviceLetterElement) {
                    const canvas = await html2canvas(serviceLetterElement, {
                        scale: 2,
                        useCORS: true
                    });
                    const imgData = canvas.toDataURL('image/png');
                    const imgWidth = pdf.internal.pageSize.getWidth();
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;

                    if (i > 0) pdf.addPage();

                    pdf.addImage(
                        headerImgData,
                        'PNG',
                        0,
                        0,
                        imgWidth,
                        headerHeight
                    );

                    pdf.addImage(
                        imgData,
                        'PNG',
                        0,
                        headerHeight,
                        imgWidth,
                        imgHeight
                    );
                }
            }
            Toast.clear(toastId);  
            Toast.info('Baixando PDF...'); 

            pdf.save(
                `carta-de-servicos-${
                    serviceLetters[0] ? serviceLetters[0].project : ''
                }-${new Date().toLocaleDateString().replace(/\//g, '-')}.pdf`
            );
        } catch (error) {
            Toast.error(`Erro ao gerar PDF: ${error.message}`);
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <div className="d-flex justify-content-end mt-2 mb-2 mr-2">
            <button
                onClick={generatePDF}
                className="btn btn-primary"
                disabled={isGenerating}
            >
                <FaFilePdf />
            </button>
        </div>
    );
};

export default PDFGeneratorButton;
